import React from "react";

import "./choose.css";
export default function ChooseBox({ setChooseBox }) {
  return (
    <div className="choose-container">
      <div className="ibcc-main" onClick={() => setChooseBox("ibcc")}>
        <span>Step 1</span>
        <h1>Generate IBCC QR</h1>
      </div>
      <div className="mofa-main" onClick={() => setChooseBox("mofa")}>
        <span>Step 2</span>
        <h1>Generate Mofa QR</h1>
      </div>
      <div className="upload-main" onClick={() => setChooseBox("upload")}>
        <span>Step 3</span>
        <h1>Upload Document</h1>
      </div>
      <div className="multiple-main" onClick={() => setChooseBox("multiple")}>
        <span>Step 4</span>
        <h1>Download Multiple QR</h1>
      </div>
       <div className="multiple-main" onClick={() => setChooseBox("all-ibcc")}>
        <span>Ibcc</span>
        <h1>All Ibccs</h1>
      </div>
      <div className="multiple-main" onClick={() => setChooseBox("all-mofa")}>
        <span>Mofa</span>
        <h1>All Mofa</h1>
      </div>
    </div>
  );
}
